import { useEffect } from 'react';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import NsContent from 'components/common/ns-content/NsContent';
import NsSkeleton from '@britishgasenergy/react-nucleus/dist/nuc-components/NsSkeleton';
import { shallowEqual, useSelector } from 'react-redux';
import { selectProduct } from 'state/abandoned-cart/abandoned-cart-slice';
import { selectIsLoading, selectProductByCode, setPriorityProductByCode } from 'state/quote/quote-slice';
import { useAppDispatch } from 'hooks/useAppDispatch';

const inMarketMessage = 'Here’s the tariff you chose. If you’d like to see more options take a look at the offers below.'
const outOfMarketMessage = 'The tariff you chose is no longer available, but we have some other great options we think you might like. Check them out below.'

export const greetingTestId = 'abandoned-cart-greeting'

export const AbandonedCartGreeting = () => {
  const dispatch = useAppDispatch();
  const isLoading = useSelector(selectIsLoading, shallowEqual);
  const abandonedCartProduct = useSelector(selectProduct, shallowEqual);

  const isInMarket = !!useSelector(selectProductByCode(abandonedCartProduct?.code), shallowEqual);

  useEffect(() => {
    if (isInMarket) {
      dispatch(setPriorityProductByCode(abandonedCartProduct?.code));
    }
  }, [isInMarket, abandonedCartProduct?.code, dispatch]);

  return (
    <NsContent data-testid={greetingTestId}>
      <NsTitle title="Welcome back" />
      { isLoading ? (
        <p data-testid="message-skeleton"><NsSkeleton type="paragraph"/></p>
      ) : (
        <p>{isInMarket ? inMarketMessage : outOfMarketMessage}</p>
      )}
      <p data-testid="return-message">
      </p>
    </NsContent>
  )
};

export default AbandonedCartGreeting;